import { router } from 'expo-router';
import {
    ArrowLeftRightIcon,
    BodyLargeRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    H5Emphasized,
    HandbagIcon,
    Icon,
    type IconType,
    isWeb,
    PiggyBankIcon,
    RotateCcwIcon,
    View,
    XStack,
    YStack,
} from 'smoothie';

const EmptyRecurringTransfers = () => {
    return (
        <YStack
            height="100%"
            justifyContent={isWeb ? 'flex-start' : 'space-between'}
            $sm={{ maxWidth: 500, alignSelf: 'center' }}
        >
            <YStack alignItems="center" gap={12} flexGrow={1}>
                <XStack alignItems="center">
                    <EmptyTransferIcon
                        primaryColor="$orange400"
                        icon={PiggyBankIcon}
                    />
                    <View
                        zIndex={1}
                        marginLeft={-18}
                        marginRight={-18}
                        padding={10}
                        borderRadius={100}
                        backgroundColor="$black"
                    >
                        <Icon icon={RotateCcwIcon} size={24} color="$white" />
                    </View>
                    <EmptyTransferIcon
                        primaryColor="$red200"
                        icon={HandbagIcon}
                    />
                </XStack>
                <H5Emphasized>Put your money on autopilot</H5Emphasized>
                <BodyLargeRegular color="$gray1000" textAlign="center">
                    Schedule recurring transfers to make your money movement
                    automatic.
                </BodyLargeRegular>
            </YStack>
            <View marginTop={isWeb ? 100 : 'auto'}>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="New transfer"
                    icon={ArrowLeftRightIcon}
                    onPress={() => {
                        router.navigate('/banking/transfer');
                    }}
                />
            </View>
        </YStack>
    );
};

interface EmptyTransferIconProps {
    primaryColor: string;
    icon: IconType;
}

const EmptyTransferIcon = ({ primaryColor, icon }: EmptyTransferIconProps) => {
    return (
        <View
            borderRadius={20}
            borderWidth={1}
            borderStyle="dashed"
            borderColor="$gray400"
            padding={6}
        >
            <XStack
                borderRadius={12}
                height={64}
                width={64}
                backgroundColor={primaryColor}
                alignItems="center"
                justifyContent="center"
            >
                <Icon icon={icon} size={24} />
            </XStack>
        </View>
    );
};

export default EmptyRecurringTransfers;
